import React from "react";

import Icon from "shared/components/Icon";

import {
    CosignBadgePill,
    CosignDropdownContainer,
    CosignDropdownHeader,
    CosignDropdownBody,
    CosignDropdownDescription,
    CosignDropdownBenefitsList,
    CosignDropdownBenefitItem,
    CosignDropdownFooter,
    CosignOnboardButton,
    CosignLearnMoreLink,
} from "./styled";
import { Popover } from "shared/components/Popover";
import { Global, css } from "@emotion/react";

export type CosignBadgeProps = {
    isEnabled: boolean;
    onOnboardClick?: () => void;
    learnMoreUrl?: string;
};



const ArrowRightIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const BENEFITS_NOT_ENABLED = [
    "100% rent default guarantee",
    "Expand your tenant pool risk-free",
];

const BENEFITS_ENABLED = [
    "100% Default Guarantee available",
    "Rent protection for qualified applicants",
    "Expand your tenant pool risk-free",
];
const getPopoverArrowStyles = (isEnabled: boolean) => css`
  .cosign-popover.ant-popover-placement-bottom .ant-popover-arrow {
    border-top-color: ${isEnabled ? "#2563EB" : "#4B5563"} !important;
    border-left-color: ${isEnabled ? "#2563EB" : "#4B5563"} !important;
    border-bottom-color: ${isEnabled ? "#2563EB" : "#4B5563"} !important;
    border-right-color: ${isEnabled ? "#2563EB" : "#4B5563"} !important;
  }
`;
export const CosignBadgeHouseIcon = ({ isEnabled }: { isEnabled: boolean }): JSX.Element => <CosignBadgePill isEnabled={isEnabled}>
    <span className="cosign-badge-icon">
        <Icon.CosignHouseIcon width={25} height={23} fillMain={isEnabled ? "#0283c5" : "#82869b"} fillHole={isEnabled ? "#fff" : "#64697e"} />
    </span>
</CosignBadgePill>

export const CosignBadge: React.FC<CosignBadgeProps> = ({
    isEnabled,
    onOnboardClick,
    learnMoreUrl = "https://www.rentwithcosign.com/",
}) => {
    const popoverArrowStyles = getPopoverArrowStyles(isEnabled);


    return (
        <>
            <Global styles={popoverArrowStyles} />
            <Popover
                className="popover"
                withoutOverlay
                placement="bottom"
                overlayClassName="cosign-popover"
                // @ts-ignore
                trigger="hover"
                content={<CosignDropdownContainer isEnabled={isEnabled}>
                    <CosignDropdownHeader isEnabled={isEnabled}>
                        <span className="cosign-dropdown-person-icon">
                            <Icon.CosignPersonIcon width={135} height={32} iconFill={isEnabled ? "#fff" : "#c3c6cb"} textFill={isEnabled ? "#fff" : "#c3c6cb"} />
                        </span>
                    </CosignDropdownHeader>

                    <CosignDropdownBody>
                        {!isEnabled && (
                            <CosignDropdownDescription>
                                This property is not yet onboarded
                                with Cosign. Enable to unlock:
                            </CosignDropdownDescription>
                        )}

                        <CosignDropdownBenefitsList>
                            {(isEnabled ? BENEFITS_ENABLED : BENEFITS_NOT_ENABLED).map(
                                (benefit, index) => (
                                    <CosignDropdownBenefitItem key={index}>
                                        <span className="cosign-benefit-icon">
                                            <Icon.CosignCheckCircleIcon width={20} height={20} />
                                        </span>
                                        <span>{benefit}</span>
                                    </CosignDropdownBenefitItem>
                                )
                            )}
                        </CosignDropdownBenefitsList>
                    </CosignDropdownBody>

                    <CosignDropdownFooter>
                        {isEnabled ? (
                            <CosignLearnMoreLink href={learnMoreUrl} target="_blank">
                                Learn more about Cosign <ArrowRightIcon />
                            </CosignLearnMoreLink>
                        ) : (
                            <CosignOnboardButton onClick={onOnboardClick}>
                                Onboard with Cosign
                            </CosignOnboardButton>
                        )}
                    </CosignDropdownFooter>
                </CosignDropdownContainer>}
            >
                <span style={{ display: "inline-flex" }}>
                    <CosignBadgeHouseIcon isEnabled={isEnabled} />
                </span>
            </Popover>
        </>

    );
};

export default CosignBadge;

